<template>
    <div class="dialogContainer" style="display: block">
        <div class="dialog modal" role="dialog">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content smartPanel">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ title }}</h5>
                    </div>
                    <div class="modal-body errorBody" v-html="message">
                    </div>
                    <div class="modal-footer">
                        <template v-for="button in buttons">
                            <button
                                    type="button"
                                    :class="['btn', button.style || 'btn-secondary'].join(' ')"
                                    @click="button.action"
                            >
                                {{ button.label }}
                            </button>
                        </template>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  export default {
    name: 'Dialog',

    computed: {
      title() {
        return this.$store.state.dialogStore.title;
      },
      message() {
        return this.$store.state.dialogStore.message;
      },
      buttons() {
        return this.$store.state.dialogStore.buttons;
      }
    },

    methods: {},
  }
</script>
<style src="./dialog.css"></style>